import { r2wc } from '#/r2wc';
import { AppLauncherComponent } from './AppLauncherComponent';

const _AppLauncherComponent = r2wc(AppLauncherComponent, {
  apps: 'string',
  issuer: 'string',
  sandbox: 'boolean',
  userKey: 'number',
});

customElements.define('unanet-app-launcher', _AppLauncherComponent);
